<div class="photo-view-container" [ngClass]="{ 'web-app': isWebApp }">
  <div class="photo-buttons">
    <ion-button fill="clear" class="left" (click)="addFileLibrary()">
      <span style="font-size: 16px; font-weight: bold; color: white"> + </span>
    </ion-button>
  </div>
</div>
